import { memo } from 'react';
import { Box } from '@mui/material';
import TableAvatar from 'views/Components/Shared/Components/TableAvatar';

const ThumbnailField = memo(({ imageUrl, name }) => (
	<Box
		sx={{
			height: '100%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		}}
	>
		<TableAvatar imageUrl={imageUrl} name={name || 'N D'} />
	</Box>
));

export default ThumbnailField;
